// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"afacea06","228":"c186e67d","357":"ded831c7","378":"a52ea961","747":"608c336b"}[chunkId] + ".chunk.css";
};